// @flow

import React, {useState} from 'react';
import styled from 'styled-components';
import {CSSTransition} from 'react-transition-group';

import type {contentType} from 'js-libs/sweetcommons/contentType';
import {PresenceConsumer} from './PresenceConsumer';
import {PresenceContextBoxes} from 'app/presence/components/PresenceContextBoxes';

const validContexts = ['view', 'edit', 'task'];

const StyledContainerDiv = styled.div`
    overflow: hidden;
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;

    .context-container {
        padding: 10px;
    }

    > .mark {
        position: absolute;
        width: 20px;
        height: 20px;
        background: #00b4cc;
        transform: rotate(45deg);
        top: -10px;
        left: -10px;
    }

        &.corner-enter,
        &.corner-appear,
        &.corner-exit.corner-exit-active {
            > .mark {
                top: -25px;
                opacity: 0.01;
            }
        }

        &.corner-exit,
        &.corner-enter.corner-enter-active,
        &.corner-appear.corner-appear-active {
            > .mark {
                top: -10px;
                opacity: 1;
            }
        }

        &.corner-exit-active,
        &.corner-enter-active,
        &.corner-appear-active {
            > .mark {
                transition: all 250ms ease-out;
            }
        }
    }

    .ct-enter,
    .ct-appear,
    .ct-exit.ct-exit-active {
        opacity: 0.01;
    }

    .ct-exit,
    .ct-enter.ct-enter-active,
    .ct-appear.ct-appear-active {
        opacity: 1;
    }

    .ct-exit-active,
    .ct-enter-active,
    .ct-appear-active {
        transition: all 250ms ease-out;
    }
`;

type Props = {
  contentType: contentType,
  objectId: string | number,
};

export const DashboardItemPresentMembers = ({contentType, objectId}: Props) => {
  const [showingUsers, showUsers] = useState<boolean>(false);

  return (
    <PresenceConsumer contentType={contentType} objectId={objectId}>
      {(contextsUsers) => (
        <CSSTransition
          timeout={250}
          classNames="corner"
          in={Object.keys(contextsUsers).length > 0}
          unmountOnExit
        >
          <StyledContainerDiv
            onMouseEnter={() => showUsers(true)}
            onMouseLeave={() => showUsers(false)}
          >
            <div className="mark" />
            <div className="context-container">
              <PresenceContextBoxes
                className="d-flex flex-column"
                direction="vertical"
                show={showingUsers}
                contexts={validContexts}
                users={contextsUsers}
                contentType={contentType}
                tooltipPlacement="right"
              />
            </div>
          </StyledContainerDiv>
        </CSSTransition>
      )}
    </PresenceConsumer>
  );
};
